<div class="btn-group choose-color" dropdown tooltip="Drawing Color" placement="right">
    <button
        type="button"
        id="toChangeColour"
        class="btn"
        [ngStyle]="{ 'background-color': selectedColor, 'border-color': selectedColor }"
        dropdownToggle>
        <i class="fa fa-paint-brush text-large"></i>
    </button>
    <ul class="dropdown-menu" *dropdownMenu role="menu">
        <li *ngFor="let color of drawingColors" role="menuitem">
            <a [ngStyle]="{ 'background-color': color }" (click)="onColorChanged(color)"></a>
        </li>
    </ul>
</div>
